import $ from "jquery";

export const initBackButton = () => {
    if (!document.referrer) {
        return;
    }

    $('.back-to-referrer').click((event) => {
        event.preventDefault();

        window.history.back();
    })
}
